export default __webpack_public_path__ + "static/12-d56fdeaeb2b0900c25225f1de6682cfb.webp";